<template>
  <div>
    <div class=" active-user-widget">
      <div class="user-card-widget daily-user" :class="{'loading-state':!loadingState}">
          <div v-if="!loadingState">
            <img src='@/assets/images/ui_loading.png'>
          </div>
          <div class="chart-area" v-else>
              <div class="header-user-widget">
                <p>Daily User</p>
                <div class="selector-chart-type">
                  <div class="item-selector-chart-type" @click="onClickSelectChartType('line')">
                    <img src="@/assets/dashboard-icon/selected-trend-up.svg" v-if="selectedTypeForDailyUserChart==='line'" class="line-chart-icon selected" alt="trend up icon">
                    <img src="@/assets/dashboard-icon/trend-up.svg" v-else  class="line-chart-icon" alt="trend up icon">
                  </div>
                  <div class="item-selector-chart-type" :class="{'selected': selectedTypeForDailyUserChart === 'column'}" @click="onClickSelectChartType('column')">
                    <i class="bx bx-bar-chart"></i>
                  </div>
                  <button v-if="Array.isArray(activeUserHistory) && activeUserHistory.length > 0" @click="exportDailyUserFile" class="export-button">
                    <p>Export</p>
                  </button>
                </div>
              </div>
              <NoResultsFound v-if="!Array.isArray(activeUserHistory) || activeUserHistory.length <= 0" class="no-result-content"/>
                <div class="chart-content" v-else>
                  <GChart class="g-chart" type="LineChart" v-if="selectedTypeForDailyUserChart==='line'" :data="activeUserHistoryLineChartData" :options="lineChartOptions"></GChart>
                  <GChart class="g-chart" type="ColumnChart" v-else :data="activeUserHistoryColumnChartData" :options="columnChartOptions"></GChart>
                </div>
              </div>
            <div :class="{'d-none': !dataChartState}" >
              <div class="chart-nodata"><p class="txt-nodata">No data</p>
            </div>
        </div>
        </div>
      <div class="user-card-widget active-time" :class="{'loading-state':!loadingState}">
        <div v-if="!loadingState">
            <img src='@/assets/images/ui_loading.png'>
        </div>
        <div v-else>
          <div class="header-user-widget">
            <div>
              <p>Active Time</p>
              <p class="text-subtitle">When user chat the most</p>
            </div>
            <button v-if="!isMaxActiveUserCountZero" @click="exportActiveTimeFile" class="export-button">
              <p>Export</p>
            </button>
          </div>
          <NoResultsFound v-if="isMaxActiveUserCountZero" class="no-result-content"/>
          <div v-else class="chart-content">
          <div :class="{'d-none': dataChartState}">
            <v-chart :options="heatmap" :class="{'v-hidden': loadingState }" id="heatmap-activetime" autoresize />
          </div>
          <div :class="{'d-none': !dataChartState}" >
            <div class="chart-nodata"><p class="txt-nodata">No data</p></div>
          </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueECharts from 'vue-echarts';
import 'echarts/lib/chart/heatmap';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/axis';
import 'echarts/lib/component/grid';
import 'echarts/lib/component/visualMap';
import { mapGetters, mapActions } from 'vuex';
import { GChart } from 'vue-google-charts';
import moment from 'moment';
import Vue from 'vue';
import NoResultsFound from '../NoResultsFound.vue';
import alice from '../../alice-api';
import { getFilenameFromContentDispositionHelper, downloadFileHelper } from '../../utiles/exportFileHelper';
// import { BButton } from 'bootstrap-vue';
const hourLabels = [
  '10pm',
  '9pm',
  '8pm',
  '7pm',
  '6pm',
  '5pm',
  '4pm',
  '3pm',
  '2pm',
  '1pm',
  '12pm',
  '11am',
  '10am',
  '9am',
  '8am',
  '7am',
  '6am',
  '5am',
  '4am',
  '3am',
  '2am',
  '1am',
  '12am',
  '11pm',
];
// prettier-ignore
const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export default {
  name: 'active-user-widget',
  components: {
    GChart,
    'v-chart': VueECharts,
    NoResultsFound
    // 'b-button': BButton,
  },
  props: {
    criteria: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      currentState: false,
      dataChartState: false,
      loadingState: true,
      lineChartOptions: {
        height: 300,
        legend: { position: 'bottom' },
        chartArea: {
        //   left: 50,
        //   top: 50,
        //   right: 20,
        //   bottom: 50,
          width: '90%',
          height: '65%',
        },
        focusTarget: 'category',
        hAxis: { showTextEvery: 4 },
        colors: ['#59CBE8', '#3371FF', '#C964CF'],
      },
      heatmap: {
        tooltip: {
          position: 'top',
        },
        animation: false,
        grid: {
          height: '90%',
          width: '80%',
          bottom: '0%',
          right: '50',
          top: '5%',
        },
        xAxis: {
          type: 'category',
          data: days,
        },
        yAxis: {
          type: 'category',
          data: hourLabels,
          axisLabel: {
            rotate: 40,
          },
        },
        visualMap: {
          show: false,
          type: 'continuous',
          min: 0,
          max: 0,
          itemGap: 1,
          calculable: true,
          splitNumber: 7,
          realtime: false,
          orient: 'horizontal',
          itemHeight: 200,
          itemWidth: 25,
          range: [0, 0],
          inRange: {
            color: ['#F2F2F2', '#3371ff'],
          },
          formatter: (value) => value,
        },
        series: [
          {
            type: 'heatmap',
            data: [],
          }
        ]
      },
      columnChartOptions: {
        isStacked: true,
        legend: { position: 'bottom' },
        height: 300,
        hAxis: { showTextEvery: 4 },
        chartArea: {
          width: '90%',
          height: '65%',
        },
        colors: ['#3371FF', '#59CBE8'],
      },
      selectedTypeForDailyUserChart: 'line',
      isMaxActiveUserCountZero: false,
    };
  },
  watch: {
    criteria: {
      handler: 'init',
      immediate: true,
    },
    activeUserDataHeatmap: {
      handler: 'convertToHeatmapData',
      immediate: true,
    }
  },
  methods: {
    ...mapActions({
      loadActiveUserData: 'dashboard/loadActiveUserData',
      loadActiveUserDataHeatmap: 'dashboard/loadActiveUserDataHeatmap',
      loadExportData: 'dashboard/loadExportData',
    }),
    async init() {
      this.loadingState = false;
      await this.loadActiveUserData({
        criteria: this.criteria,
      });
      await this.loadActiveUserDataHeatmap({
        criteria: this.criteria,
      });
      this.checkedValue();
    },
    convertTime(ms) {
      const input = moment.duration(ms);
      if (input.as('hours') >= 1) return input.as('hours').toFixed(2);
      if (input.as('minutes') >= 1) return input.as('minutes').toFixed(2);
      return input.as('seconds');
    },
    convertUnit(ms) {
      const input = moment.duration(ms);
      if (input.as('hours') >= 1) return 'hour(s)';
      if (input.as('minutes') >= 1) return 'minute(s)';
      if (input.as('seconds') >= 1) return 'second(s)';
      return 'second';
    },
    convertToHeatmapData() {
      if (this.activeUserDataHeatmap && typeof this.activeUserDataHeatmap === 'object' && Object.keys(this.activeUserDataHeatmap).length > 0) {
        const output = [];
        let maxActiveUserCount = 0;
        Object.entries(this.activeUserDataHeatmap.activeTime).forEach(([day, hoursValue]) => {
          hoursValue.forEach((item) => {
            output.push([this.replaceDayNamesWithNumbers(day), item.hour, item.activeUserCount]);
            if (maxActiveUserCount < item.activeUserCount) {
              maxActiveUserCount = item.activeUserCount;
            }
          });
        });
        this.isMaxActiveUserCountZero = maxActiveUserCount <= 0;
        this.heatmap.series[0].data = output;
        this.heatmap.visualMap.range = [0, maxActiveUserCount];
        this.heatmap.visualMap.max = maxActiveUserCount;
      } else {
        this.heatmap.series[0].data = [];
      }
    },
    replaceDayNamesWithNumbers(day) {
      const dayInLowercase = day.toLowerCase();
      const dayToNumber = {
        monday: 0,
        tuesday: 1,
        wednesday: 2,
        thursday: 3,
        friday: 4,
        saturday: 5,
        sunday: 6,
      };
      return dayToNumber[dayInLowercase] !== undefined ? dayToNumber[dayInLowercase] : null;
    },
    checkedValue() {
      this.loadingState = false;
      window.dispatchEvent(new Event('resize'));
      this.convertToHeatmapData();
      this.loadingState = true;
    },
    async exportData() {
      await this.loadExportData({
        criteria: this.criteria,
      });
    },
    onClickSelectChartType(chartType) {
      this.selectedTypeForDailyUserChart = chartType;
    },
    hAxisController(totalDataCount) {
      // Control displayed h-axis
      if (totalDataCount <= 10) {
        this.lineChartOptions.hAxis.showTextEvery = 1;
        this.columnChartOptions.hAxis.showTextEvery = 1;
      } else if (totalDataCount > 10 && totalDataCount <= 20) {
        this.lineChartOptions.hAxis.showTextEvery = 2;
        this.columnChartOptions.hAxis.showTextEvery = 2;
      } else {
        this.lineChartOptions.hAxis.showTextEvery = 4;
        this.columnChartOptions.hAxis.showTextEvery = 4;
      }
    },
    async exportDailyUserFile() {
      if (!this.criteria) return;
      const response = await alice.exportDailyUser(this.criteria);
      const filename = getFilenameFromContentDispositionHelper(response);
      downloadFileHelper(response.data, filename);
    },
    async exportActiveTimeFile() {
      if (!this.criteria) return;
      const response = await alice.exportActiveTime(this.criteria);
      const filename = getFilenameFromContentDispositionHelper(response);
      downloadFileHelper(response.data, filename);
    },
  },
  computed: {
    ...mapGetters({
      activeUserData: 'dashboard/activeUserData',
      activeUserStat: 'dashboard/activeUserStat',
      activeUserHistory: 'dashboard/activeUserHistory',
      activeUserDataHeatmap: 'dashboard/activeUserDataHeatmap',
    }),
    activeUserHistoryLineChartData() {
      const { criteria } = this;
      let header = ['Date', 'New user', 'Return user', 'Total User'];
      let dateFormat = '';
      if (criteria) {
        if (criteria.time.granularity === 'month') {
          header = ['Month', 'New user', 'Return user', 'Total User'];
          dateFormat = 'M/YY';
        } else if (criteria.time.granularity === 'day') {
          header = ['Date', 'New user', 'Return user', 'Total User'];
          dateFormat = 'D MMM';
        } else if (criteria.time.granularity === 'hour') {
          header = ['Hour', 'New user', 'Return user', 'Total User'];
          dateFormat = 'HH:mm';
        }
      }
      if (this.activeUserHistory && this.activeUserHistory.length !== 0) {
        const dataList = this.activeUserHistory.map((obj) => [moment(obj.date).format(dateFormat), obj.newUser, obj.returnUser, obj.totalUser]);
        Vue.set(this, 'dataChartState', false);
        this.hAxisController(dataList.length);
        return [header, ...dataList];
      }
      return [header, ['No data', 0, 0]];
    },
    activeUserHistoryColumnChartData() {
      const { criteria } = this;
      let header = ['Date', 'New user', 'Return user'];
      let dateFormat = '';
      if (criteria) {
        if (criteria.time.granularity === 'month') {
          header = ['Month', 'New user', 'Return user'];
          dateFormat = 'M/YY';
        } else if (criteria.time.granularity === 'day') {
          header = ['Date', 'New user', 'Return user'];
          dateFormat = 'D MMM';
        } else if (criteria.time.granularity === 'hour') {
          header = ['Hour', 'New user', 'Return user'];
          dateFormat = 'HH:mm';
        }
      }
      if (this.activeUserHistory && this.activeUserHistory.length !== 0) {
        const dataList = this.activeUserHistory.map((obj) => [moment(obj.date).format(dateFormat), obj.newUser, obj.returnUser]);
        Vue.set(this, 'dataChartState', false);
        this.hAxisController(dataList.length);
        return [header, ...dataList];
      }
      return [header, ['No data', 0, 0]];
    },
  },
};
</script>
<style lang="scss" scoped>
.active-user-widget{
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 24px;
  .user-card-widget{
    background-color: #FFFFFF;
    border-radius: 16px;
    height: 100%;
    .header-user-widget{
      padding: 16px 16px 12px 16px;
      border-bottom: 1px solid #E9EBEC;
      font-size: 16px;
      font-weight: 500;
      line-height: 19.2px;
      color: #111B49;
      display: flex;
      justify-content: space-between;
      align-items: center;
      p {
          margin-bottom: 0px
      }
    .line-chart-icon {
      height: 16px;
      width: 16px;
      margin-right: 8px;
    }
    .line-chart-icon.selected{
      height: 32px;
      width: 32px;
      margin-right: 8px;
    }

    .selector-chart-type{
      display: flex;
      align-items: center;
      .item-selector-chart-type{
        color: #868BA6;
        width: 32px;
        height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .item-selector-chart-type.selected{
        background-color: rgba(51, 113, 255, 0.1);
        color: #3371FF;
        border-radius: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        // width: 32px;
        // height: 32px;
      }
    }
    }

    .text-subtitle{
      font-size: 10px;
      font-weight: 400;
      line-height: 15px;
      color: #878A99;
    }
    .chart-area{
      display: flex;
      flex-direction: column;
      height: 100%;
    }
  }
  .no-result-content{
    margin-top: 97px;
    margin-bottom: 97px;
  }
  .user-card-widget.loading-state{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 400px;
  }
  .user-card-widget.daily-user{
    grid-column: span 4 / span 4;
    .chart-content{
      padding: 24px 20px;
    }
  }
  .user-card-widget.active-time{
    grid-column: span 3 / span 3;
    .chart-content{
      padding: 20px;
    }
  }
}
.export-button {
  border-radius: 24px;
  border: 1px solid #DADCE4;
  padding: 4px 12px;
  margin-left: 8px;
  color: #4848FF;
  background-color: #fff;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  outline: none;
}
.echarts {
  width: 100%;
  height: 350px;
}
.chart-nodata{
  height: 290px;
  opacity: 0.5;
  display: flex;
  justify-content: center;
}
.txt-nodata{
  margin-top: auto;
  margin-bottom: auto;
}
.toggle__button {
  vertical-align: middle;
  user-select: none;
  cursor: pointer;
}
.toggle__button input[type='checkbox'] {
  opacity: 0;
  position: absolute;
  width: 1px;
  height: 1px;
}
.toggle__button .toggle__switch {
  display: inline-block;
  height: 12px;
  border-radius: 6px;
  width: 40px;
  background: #9ca8b6;
  box-shadow: inset 0 0 1px #bfcbd9;
  position: relative;
  margin-left: 10px;
  transition: all 0.25s;
}

.toggle__button .toggle__switch::after,
.toggle__button .toggle__switch::before {
  content: '';
  position: absolute;
  display: block;
  height: 18px;
  width: 18px;
  border-radius: 50%;
  left: 0;
  top: -3px;
  transform: translateX(0);
  transition: all 0.25s cubic-bezier(0.5, -0.6, 0.5, 1.6);
}

.toggle__button .toggle__switch::after {
  background: #4d4d4d;
  box-shadow: 0 0 1px #666;
}
.toggle__button .toggle__switch::before {
  background: #4d4d4d;
  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.1);
  opacity: 0;
}
.toggle__button .toggle__switch.active::after {
  right: 0px;
  left: unset;
  background: #3371ff;
}
#loadingactiveUser{
    position: absolute;
    width: 100%;
    height: 95%;
    display: flex;
    justify-content: center;
    background: white;
    align-items: center;
    z-index: 1;
    opacity: 1;
}
.link-export{
  color: #00bcd4;
}
.link-export:hover{
  color: #00bcd4;
  text-decoration: underline;
  cursor: pointer;
}
</style>
